import {
    CO_GET_PACKAGING_LISTING,
    CO_GET_PACKAGING_LISTING_SUCCESS,
    CO_GET_PACKAGING_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    packaging: null,
  }
  
  const coPackaging = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_PACKAGING_LISTING:
        state = {
          ...state,
          loading: true,
          packaging: action.payload,
        }
        break
      case CO_GET_PACKAGING_LISTING_SUCCESS:
        state = { ...state, loading: false, packaging: action.payload }
        break
      case CO_GET_PACKAGING_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coPackaging
  